<template>
  <tbody>
  <tr :class="['clickable', { updated: isLastVisited(entity.id) }]" @click="goToDetail($event, entity.id)">
    <td class="no_padding drag_drop"><span></span></td>
    <td class="no_padding">
      <span
          v-if="!$_updateActionAllowed"
          class="lock"
          :title="'Uzamknuto' | translate"
          v-translate>
      </span>
      <input type="checkbox"
             :id="entity.id"
             :value="entity.id"
             @click.stop
             @change="onChange"
             :checked="isChecked"
      />
      <label
          :for="entity.id"
          @click.stop
          v-translate>Vybrat
      </label>
    </td>
    <td :data-th="'Název' | translate">
      <strong>{{ entity.name }}</strong>
    </td>
    <td :data-th="'Operátor' | translate">
      <entity-link :id="entity.id_operator" type="operator">{{ entity.operator_name }}</entity-link>
    </td>
    <td :data-th="'Dostupné na zařízení' | translate">
      <img
          class="is_set"
          src="../../../assets/images/is-set.svg"
          :alt="'Ano' | translate"
          v-if="entity.device_visibility">
    </td>
    <td :data-th="'Systémová skupina' | translate">
      <img
          class="is_set"
          src="../../../assets/images/is-set.svg"
          :alt="'Ano' | translate"
          v-if="!entity.custom_group">
    </td>
    <td :data-th="'Počet kanálů' | translate" v-if="entity.channels_count">
          <span class="dotted" @click.stop="$refs.channelsmodalref.showModal(true)">
                {{ entity.channels_count }}
              <modal ref="channelsmodalref">
                <div slot="title"><translate>Kanály v tématické skupině</translate> ({{entity.channels_count}})</div>
                <div slot="body">
                  <ul>
                    <li v-for="(item, index) in filteredChannels" :key="'channels-'+index">{{item.name}}
                    <channel-video-quality-label v-if="item.video_quality" :quality="item.video_quality"></channel-video-quality-label>
                    </li>
                  </ul>
                </div>
              </modal>
            </span>
    </td>
    <td :data-th="'Počet kanálů' | translate" v-else></td>
    <td :data-th="'Vytvořeno' | translate" v-html="$_date_formatFull(entity.date_created)"></td>
    <td :data-th="'Upraveno' | translate" v-html="$_date_formatFull(entity.date_updated)"></td>
    <td class="no_padding edit">
      <div class="edit_inner">
        <a
            v-if="$_deleteActionAllowed && entity.custom_group"
            class="btn btn_action btn_delete"
            :title="'Smazat' | translate"
            @click.prevent.stop="emitDeleteThematicGroup">
          <translate class="translate">Smazat</translate>
        </a>
        <a
            v-if="$_updateActionAllowed && entity.id_operator && !entity.custom_group"
            class="btn btn_action btn_grey btn_reset"
            :title="$gettext('Resetovat')"
            @click.prevent.stop="emitDeleteThematicGroup">
          <translate class="translate">Smazat</translate>
        </a>
      </div>
    </td>
  </tr>
  </tbody>
</template>

<script>
import rowActions from "@/components/mixins/row-actions"
import ChannelVideoQualityLabel from "../../common/ChannelVideoQualityLabel.vue";
import EntityLink from "../../common/EntityLink.vue";

export default {
  name: "TagsRow",
  components: { EntityLink, ChannelVideoQualityLabel},
  mixins: [rowActions],
  props: {
    entity: Object,
    allChannels: Array,
  },
  data(){
    return{
      detailPageRouteName: "thematicGroupDetail",
    }
  },
  computed: {
    filteredChannels(){
      return this.allChannels.filter((item) => this.entity.id_channels.includes(item.id));
    }
  },
  methods: {
    emitDeleteThematicGroup() {
      this.$emit('deleteThematicGroup', String(this.entity.id))
    },
  }
}
</script>



// WEBPACK FOOTER //
// src/components/views/thematicGroups/ThematicGroupRow.vue